import styled from 'styled-components';
import { Collapse } from 'antd';
export const AudioContainer = styled.div`
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border: 1px solid rgba(238, 241, 240, 1);
`;

export const PageName = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ThemeCollapse = styled(Collapse)`
  margin-bottom: 16px;
  background-color: white;
  min-height: 56px;

  &.active {
    background-color: rgba(231, 250, 255, 1);
  }


  .ant-collapse-item.ant-collapse-item-active {
  background: rgba(231, 250, 255, 1);
  border-radius: 8px !important;
    .ant-typography.sc-braxZu.kVzYNl.css-dev-only-do-not-override-vr30i2 {
        color: rgba(0, 141, 210, 1) !important;
    }
  }

  .ant-collapse-item {
  background: #fff;
  border-radius: 8px !important;
  }

  .ant-collapse-header {
  flex-direction: row-reverse;
  padding: 17px !important;
  }
  
  .ant-collapse-header-text{
  max-width: 190px;
  }
`;

export const PlayPauseButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  outline: none;
  margin-right: 16px;
`;

export const ProgressBar = styled.input`
  width: 242px;
  margin: 0 10px;
  appearance: none;
  height: 4px;
  border-radius: 4px;
  cursor: pointer;
  background: ${({ value }) => 
    `linear-gradient(to right, #0a033c ${value}%, #ddd ${value}%)`};

  &::-webkit-slider-thumb {
    appearance: none;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #0a033c;
  }
`;

export const StyledButton = styled.button`
  width: 130px;
  height: 56px;
  margin-top: 16px;
  background-color: rgba(244, 245, 247, 1);
  border: 1.5px solid rgba(229, 233, 242, 1);
  border-radius: 8px;
  color: #0A033C;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  outline: none;

  &:hover {
    background-color: rgba(229, 233, 242, 1);
  }
`;